/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 */

var tag = document.createElement('script');

tag.src = "https://www.youtube.com/iframe_api";
var firstScriptTag = document.getElementsByTagName('script')[0];
firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);

var vimeoTag = document.createElement('script');
vimeoTag.src = "https://player.vimeo.com/api/player.js";
firstScriptTag.parentNode.insertBefore(vimeoTag, firstScriptTag);

window.onload = function () {
    var elementsVideoArray = document.querySelectorAll(".Product__SlideItem--video");
    elementsVideoArray = [].slice.call(elementsVideoArray);
    elementsVideoArray.forEach(function (elem) {
        elem.addEventListener("click", addPlayer.bind(this, elem));
    });

    showStickyBtn();
    fixedColumnsMegamenu();
    sendFormSticky();
    createBreadCrumbs();
    modalLocation();
    geoipLocation();
    cartLang();

    //Translation change
    /*
        if (document.querySelector(".js-lang-current")) {
            document.querySelector(".js-lang-current").innerHTML = document.querySelector(".js-lang-current").getAttribute("data-dafault");
            var elementsModalLocationText = document.querySelectorAll('.js-modal-location-text');
            for (var i = 0; i < elementsModalLocationText.length; i++) {
                var elem = elementsModalLocationText[i];
                elem.addEventListener("click", function (e) {
                    document.querySelector(".js-lang-current").innerHTML = e.target.getAttribute("data-name");
                    var modal = document.getElementById('modalLocation');
                    modal.classList.remove("active");
                    const date = new Date(
                        new Date().getTime() + 1000 * 60 * 60 * 24 * 365
                    );
                    document.cookie = 'gobik_selected_language=' + e.target.getAttribute("data-lang") + '; path=/; expires=' + date.toUTCString();
                });
            }
        }
    */
    var locale = getUrlParameter('locale');
    if (locale != undefined && Weglot != undefined) {
        Weglot.switchTo(locale);
    }
    /*
    if (document.querySelector(".js-lang-current")) {
        if (document.querySelector(".weglot-link--active")) {
            document.querySelector(".js-lang-current").innerHTML = document.querySelector(".weglot-link--active").getAttribute("data-name");
        }
    }

     */
};

window.onscroll = function () {
    showStickyBtn();
};

function cartLang() {
    if (document.querySelector('.js-cart-lang')) {
        var lang = getGobikCookie("gobik_selected_language");
        if (lang != undefined) {
            document.querySelector('.js-cart-lang').value = lang;
        } else {
            document.querySelector('.js-cart-lang').value = 'es';
        }
    }
}

function sendFormSticky() {
    if (document.querySelector('#addToCart-sticky')) {
        var btn = document.querySelector('#addToCart-sticky');

        btn.addEventListener('click', function (e) {
            var mainSelectVal = document.querySelector('.product-select-main').value;
            document.querySelector('.product-select-sticky').value = mainSelectVal;
        })
    }
}

function setLocationSwitcherLocation(countryCode) {
    $("#country--selector").val(countryCode);

    if (!$("#country--selector").val()) {
        $("#country--selector").val("ES");
    }

    updateModalLocationSwitcher();
    updateSelectedLanguage();
}

function updateModalLocationSwitcher() {
    $('#modalLocationSwitcher').attr('data-selected-region', $(':selected', $('#country--selector')).attr('data-segment-id'))
}

function updateSelectedLanguage() {
    const availableLanguages = ['es', 'en', 'fr', 'it'];
    const preferredLanguage = navigator.language || navigator.userLanguage;

    const preferredAvailableLanguages = availableLanguages.filter(availableLanguage => preferredLanguage.includes(availableLanguage));

    const preselectedLanguage = getGobikCookie('gobik_selected_language');

    setPreferedLanguage(preselectedLanguage, preferredAvailableLanguages.length > 0 ? preferredAvailableLanguages[0] : 'en');
}

function setPreferedLanguage(preselectedLanguage, preferedLanguage) {
    let languageToUse = preselectedLanguage ? preselectedLanguage : preferedLanguage;
    if (Weglot) {
        Weglot.switchTo(languageToUse);
    }

    $('.language-selector--wrapper .lang--selected').removeClass('lang--selected');
    $('.language-selector--wrapper [data-lang="' + languageToUse + '"]').addClass('lang--selected');

    $('.correct-store .lang--selected').removeClass('lang--selected');
    $('.correct-store [data-lang="' + languageToUse + '"]').addClass('lang--selected');
}

$('#country--selector').on('change', function (event) {
    updateModalLocationSwitcher();
});

function geoipLocation() {
    var modal = document.getElementById('modalLocationSwitcher');
    var warningModal = document.getElementById('modalLocationWarning');
    //var modalMini = document.getElementById('modalLocationSwitcherMini');
    var geoIpUrl = Shopify.shop !== "test-gobik.myshopify.com" ? "https://app.gobik.com/geoip" : "https://devapp.gobik.com/geoip";

    if (!geoIpUrl || !modal) {
        return;
    }

    var countriesMap = {
        'gobikdemo.myshopify.com': ['ES', 'PT', 'AD'],
        'eugobikdemo.myshopify.com': ['All EU', '!ES', '!PT'],
        'ccgobikdemo.myshopify.com': ['World', 'GB', 'US', 'CA', 'CO', 'AR', 'CR', 'CL', 'AU', 'NZ', 'JP', 'TW', 'KR'],
    };

    var storesMap = {
        'gobikdemo.myshopify.com': "SPAIN",
        'eugobikdemo.myshopify.com': "EUROPE",
        'ccgobikdemo.myshopify.com': "REST_WORLD",
    };

    var oReq = new XMLHttpRequest();
    oReq.onload = function () {
        if (this.status === 200) {
            updateSelectedLangFooterText();
            var response = JSON.parse(this.responseText);
            var currentMap = countriesMap[Shopify.shop];
            const date = new Date(
                new Date().getTime() + 1000 * 60 * 60 * 24 * 365
            );

            setLocationSwitcherLocation(response.code);
            setGobikCookie('gobik_detected_country_29-12', response.name, {expires: date, path: '/', domain: "gobik.com"});
            if (currentMap && currentMap.indexOf('!' + response.code) === -1) {
                if (currentMap.indexOf(response.code) !== -1) {
                    return;
                }

                if (response.isInEuropeanUnion && currentMap.indexOf('All EU') !== -1) {
                    return;
                }

                if ((currentMap.indexOf('World') !== -1) && !response.isInEuropeanUnion) {
                    return;
                }
            }

            if(getGobikCookie("gobik_selected_language") !== undefined && getGobikCookie("gobik_country_29-12") !== undefined) {
                const europeCountries = ['AT', 'BE', 'BG', 'HR', 'CY', 'CZ', 'DK', 'EE', 'FI', 'FR', 'DE', 'GR', 'HU', 'IS', 'IE', 'IM', 'IL', 'IT', 'MC', 'SK', 'SI', 'CH', 'GB'];
                const worldCountries = ['AR', 'AU', 'CA', 'CL', 'CO', 'CR', 'GT', 'HK', 'IN', 'ID', 'JP', 'MY', 'MX', 'NZ', 'PY', 'PE', 'PH', 'SG', 'ZA', 'KR', 'TW', 'US'];
                const spainCountries = ['ES', 'PT', 'AD'];

                const currentStore = storesMap[Shopify.shop] || "REST_WORLD";
                let recommendedStore = "REST_WORLD";

                if (europeCountries.includes(response.code)) {
                    recommendedStore = "EUROPE";
                } else if (spainCountries.includes(response.code)) {
                    recommendedStore = "SPAIN";
                }

                if (currentStore === recommendedStore) {
                    return;
                }

                warningModal.classList.add("active");

                if (getGobikCookie('gobik_warning_modal_footer_mode') !== undefined) {
                    warningModal.classList.add("footer-mode");
                    $('#shopify-section-location-warning').addClass('footer-mode');
                }

                $('.current-store').attr('data-selected-region', currentStore);
                $('.correct-store').attr('data-selected-region', recommendedStore);
                $('.current-store .warning').text(getGobikCookie("gobik_country_29-12"));
                $('.current-store .go-to-store-button').text(getGobikCookie("gobik_country_29-12"));
                $('.correct-store .go-to-store-button').text(response.name);
            }
        }
    };

    oReq.open('get', geoIpUrl, true);
    oReq.send();
}


function modalLocation(afterTranslate) {
    var btn = document.getElementById('show-modal'),
        languageModal = document.getElementById('modalLocation'),
        locationModal = document.getElementById('modalLocationSwitcher'),
        fon = document.querySelector('.modal-location__fon');

    $('[data-go-to-shop]').on('click', function (e) {
        e.preventDefault();
        const date = new Date(
            new Date().getTime() + 1000 * 60 * 60 * 24 * 365
        );
        let selectedLanguage = $($($(this).parent()).parent()).find('.lang--option.lang--selected');

        if (!selectedLanguage) {
            selectedLanguage = $(".js-modal-location-text");
        }

        if ($(this).attr('data-button-location-selector') !== undefined) {
            setGobikCookie('gobik_country_29-12', $(':selected', $('#country--selector')).text(),{expires: date, path: '/', domain: "gobik.com"});
        } else {
            setGobikCookie('gobik_country_29-12', getGobikCookie('gobik_detected_country_29-12'),{expires: date, path: '/', domain: "gobik.com"});
        }

        setGobikCookie('gobik_selected_language', selectedLanguage.attr("data-lang"), {expires: date, path: '/', domain: "gobik.com"});
        setGobikCookie('location-redirect-to', $(this).attr('href') + '?locale=' + selectedLanguage.attr("data-lang"), {expires: date, path: '/', domain: "gobik.com"});

        if (this.host != window.location.host) {
            if (window.location.pathname != "/") {
                window.location.href = $(this).attr('href') + window.location.pathname + '?locale=' + selectedLanguage.attr("data-lang");
            } else {
                window.location.href = $(this).attr('href') + '?locale=' + selectedLanguage.attr("data-lang");
            }
        } else if (locationModal) {
            locationModal.classList.remove("active");
            $('body').css({
                overflow: ''
            });
            if (Weglot) {
                Weglot.switchTo(selectedLanguage.attr("data-lang"));
            }
            geoipLocation();
            updateSelectedLangFooterText()
        }
    });

    fon.addEventListener('click', function (e) {
        e.preventDefault();
        languageModal.classList.remove("active");
        const date = new Date(
            new Date().getTime() + 1000 * 60 * 60 * 24 * 365
        );
        var selectedLanguage = document.querySelector(".js-modal-location-text.weglot-link--active");

        if (!selectedLanguage) {
            selectedLanguage = document.querySelector(".js-modal-location-text");
        }

        setGobikCookie('gobik_selected_language', selectedLanguage.getAttribute("data-lang"), {expires: date, path: '/', domain: "gobik.com"});
    });

    if(afterTranslate) {
        return;
    }

    if (locationModal) {
        if (window.location.pathname !== "/pages/politica-de-privacidad" && !Shopify.designMode && getGobikCookie("gobik_selected_language") === undefined) {
            locationModal.classList.add("active");
            $('body').css({
                overflow: 'hidden'
            });
        } else {
            locationModal.classList.remove("active");
            geoipLocation();
        }
    }
}

function fixedColumnsMegamenu() {
    var linklistArray = document.querySelectorAll(".MegaMenu__Inner ul.Linklist");
    linklistArray = [].slice.call(linklistArray);
    linklistArray.forEach(function (elem) {
        var itemsArr = elem.querySelectorAll('li.Linklist__Item'),
            firstLevelElArr = elem.closest('div.MegaMenu__Inner').querySelectorAll('div.MegaMenu__Item--fit'),
            parentMegaMenu = elem.closest('.MegaMenu');

        if (itemsArr.length > firstLevelElArr.length) {
            // var countCol = Math.ceil(itemsArr.length / firstLevelElArr.length);
            var countCol = 2;
            elem.setAttribute("style", "column-fill: balance;  column-count: " + countCol + "; bottom: auto; width: " + countCol * 250 + "px;");

            setTimeout(function () {
                if (elem.offsetHeight + 64 > parentMegaMenu.offsetHeight) {
                    parentMegaMenu.style.minHeight = elem.offsetHeight + 64 + 'px'
                }
            }.bind(elem), 1000)
        }
    })
}

function createBreadCrumbs() {
    if (document.getElementById('breadcrumb')) {
        var url = window.location.pathname,
            breadcrumb = document.getElementById('breadcrumb'),
            urlArr = url.split('/');

        var els,
            breadcrumbInner = document.createElement('div'),
            spanEl = document.createElement('span'),
            spanText, spanNode;


        if (urlArr.length < 4) {
            els = document.querySelector(".HorizontalList a[href='" + url + "']");

            if (!els) {
                document.getElementById('breadcrumbDefault').style.opacity = 1;
                return false;
            }
            if (els.classList.contains('MegaMenu__Title')) {
                spanText = els.textContent;
                spanNode = document.createTextNode(spanText.replace("hot", "").replace("new", "").replace("sale", "").trim());
                spanEl.appendChild(spanNode);

                getTopLevelCrumbs();
            } else if (els.classList.contains('Link--secondary')) {
                spanText = els.textContent;
                spanNode = document.createTextNode(spanText.replace("hot", "").replace("new", "").replace("sale", "").trim());
                spanEl.appendChild(spanNode);

                getTopLevelCrumbs();
                getDeepLevelCrumbs();

            } else {
                spanText = els.querySelector('.Header__LinkSpacer').innerText;
                spanNode = document.createTextNode(spanText.replace("hot", "").replace("new", "").replace("sale", "").trim());
                spanEl.appendChild(spanNode);
            }


        } else {
            els = document.querySelector(".HorizontalList a[href='/" + urlArr[1] + "/" + urlArr[2] + "']");

            if (!els) {
                document.getElementById('breadcrumbDefault').style.opacity = 1;
                return false;
            }

            spanText = breadcrumb.getAttribute('data-propuct-name');
            if (spanText != null) {
                spanNode = document.createTextNode(spanText.trim());
                spanEl.appendChild(spanNode);
            }

            if (els.classList.contains('MegaMenu__Title')) {
                getTopLevelCrumbs();
                createParentLinkProduct(els)

            } else if (els.classList.contains('Link--secondary')) {
                getTopLevelCrumbs();
                getDeepLevelCrumbs();
                createParentLinkProduct(els);
            } else {
                createParentLinkProduct(els);
            }
        }

        breadcrumbInner.appendChild(spanEl);
        document.getElementById('breadcrumbDefault').style.display = 'none';
        breadcrumb.appendChild(breadcrumbInner);

        function getTopLevelCrumbs() {
            var parentTitle = els.closest('.MegaMenu'),
                slash = document.createTextNode(' / ')
            prevEl = parentTitle.previousSibling,
                prevElUrl = prevEl.getAttribute('href'),
                prevElText = prevEl.querySelector('.Header__LinkSpacer').innerText.trim(),
                parentLink = document.createElement('a'),
                parentLinkNode = document.createTextNode(prevElText);

            parentLink.appendChild(parentLinkNode);
            parentLink.setAttribute('href', prevElUrl);

            breadcrumbInner.appendChild(parentLink);
            breadcrumbInner.appendChild(slash)
        }

        function getDeepLevelCrumbs() {
            var parentTitle = els.closest('.Linklist'),
                slash = document.createTextNode(' / '),
                prevEl = parentTitle.previousSibling,
                prevElUrl = prevEl.getAttribute('href'),
                prevElText = prevEl.textContent.trim(),
                parentLink = document.createElement('a'),
                parentLinkNode = document.createTextNode(prevElText);

            parentLink.appendChild(parentLinkNode);
            parentLink.setAttribute('href', prevElUrl);

            breadcrumbInner.appendChild(parentLink);
            breadcrumbInner.appendChild(slash)
        }

        function createParentLinkProduct(el) {
            var linkText = el.querySelector('.Header__LinkSpacer') ? el.querySelector('.Header__LinkSpacer').innerText : el.textContent,
                slash = document.createTextNode(' / '),
                elUrl = el.getAttribute('href'),
                parentLink = document.createElement('a')
            linkNode = document.createTextNode(linkText.replace("hot", "").replace("new", "").replace("sale", "").trim());

            parentLink.appendChild(linkNode);
            parentLink.setAttribute('href', elUrl);

            breadcrumbInner.appendChild(parentLink);
            breadcrumbInner.appendChild(slash)
        }

    }
}

function showStickyBtn() {
    if (document.querySelector('.Product__Wrapper .ProductForm__AddToCart')) {
        var $el = document.querySelector('.Product__Wrapper .ProductForm__AddToCart'),
            posTopButton = $el.getBoundingClientRect(),
            heightEl = $el.getBoundingClientRect().height,
            stickyBtn = document.querySelector('.product-sticky');

        if (posTopButton.top + heightEl < -50) {
            stickyBtn.classList.add("active");
        } else {
            stickyBtn.classList.remove("active");
        }
    }

}

function addPlayer(parent) {

    var player,
        dataImageId = parent.getAttribute("data-image-id"),
        videoLink = parent.getAttribute("data-link-video"),
        videoId = theme.GetVideoID(videoLink).id,
        videoService = theme.GetVideoID(videoLink).service,
        blockId = 'video-block-' + dataImageId,
        videoBlockImg = parent.querySelector('.AspectRatio'),
        videoBlockImgWidth = videoBlockImg.width;

    videoBlockImg.classList.add('hide');
    if (videoService === 'youtube') {
        player = new YT.Player(blockId, {
            height: '100%',
            width: '100%',
            videoId: videoId,
            playerVars: {
                'autoplay': 0,
                'controls': 1,
                'rel': 0,
                'fs': 0,
            },
            events: {
                'onReady': onPlayerReady,
                'onStateChange': onPlayerStateChange
            }
        });

        function onPlayerReady(event) {
            event.target.playVideo();
        }

        function onPlayerStateChange(event) {
            if (event.data == YT.PlayerState.ENDED) {
                videoBlockImg.classList.remove('hide');
            }
        }
    }
    if (videoService === 'vimeo') {
        var options = {
            id: videoId,
            width: videoBlockImgWidth
        };

        player = new Vimeo.Player(blockId, options);

        player.setVolume(0.7);

        player.on('play', function () {
            // console.log('played the video!');
        });
    }

}

theme.GetVideoID = function (str) {
    if (typeof str !== 'string') {
        throw new TypeError('get-video-id expects a string');
    }

    /**
     * Get the vimeo id.
     * @param {string} str - the url from which you want to extract the id
     * @returns {string|undefined}
     */
    function vimeo(str) {
        if (str.indexOf('#') > -1) {
            str = str.split('#')[0];
        }
        if (str.indexOf('?') > -1 && str.indexOf('clip_id=') === -1) {
            str = str.split('?')[0];
        }

        var id;
        var arr;

        if (/https?:\/\/vimeo\.com\/[0-9]+$|https?:\/\/player\.vimeo\.com\/video\/[0-9]+$|https?:\/\/vimeo\.com\/channels|groups|album/igm.test(str)) {
            arr = str.split('/');
            if (arr && arr.length) {
                id = arr.pop();
            }
        } else if (/clip_id=/igm.test(str)) {
            arr = str.split('clip_id=');
            if (arr && arr.length) {
                id = arr[1].split('&')[0];
            }
        }

        return id;
    }

    /**
     * Get the Youtube Video id.
     */
    function youtube(str) {
        // shortcode
        var shortcode = /youtube:\/\/|https?:\/\/youtu\.be\//g;

        if (shortcode.test(str)) {
            var shortcodeid = str.split(shortcode)[1];
            return stripParameters(shortcodeid);
        }

        // /v/ or /vi/
        var inlinev = /\/v\/|\/vi\//g;

        if (inlinev.test(str)) {
            var inlineid = str.split(inlinev)[1];
            return stripParameters(inlineid);
        }

        // v= or vi=
        var parameterv = /v=|vi=/g;

        if (parameterv.test(str)) {
            var arr = str.split(parameterv);
            return arr[1].split('&')[0];
        }

        // v= or vi=
        var parameterwebp = /\/an_webp\//g;

        if (parameterwebp.test(str)) {
            var webp = str.split(parameterwebp)[1];
            return stripParameters(webp);
        }

        // embed
        var embedreg = /\/embed\//g;

        if (embedreg.test(str)) {
            var embedid = str.split(embedreg)[1];
            return stripParameters(embedid);
        }

        // user
        var userreg = /\/user\/(?!.*videos)/g;

        if (userreg.test(str)) {
            var elements = str.split('/');
            return stripParameters(elements.pop());
        }

        // attribution_link
        var attrreg = /\/attribution_link\?.*v%3D([^%&]*)(%26|&|$)/;

        if (attrreg.test(str)) {
            return str.match(attrreg)[1];
        }
    }

    function stripParameters(str) {
        // Split parameters or split folder separator
        if (str.indexOf('?') > -1) {
            return str.split('?')[0];
        } else if (str.indexOf('/') > -1) {
            return str.split('/')[0];
        }
        return str;
    }

    // remove surrounding whitespaces or linefeeds
    str = str.trim();

    // remove the '-nocookie' flag from youtube urls
    str = str.replace('-nocookie', '');

    // remove any leading `www.`
    str = str.replace('/www.', '/');

    var metadata = {};

    // Try to handle google redirection uri
    if (/\/\/google/.test(str)) {
        // Find the redirection uri
        var matches = str.match(/url=([^&]+)&/);

        // Decode the found uri and replace current url string - continue with final link
        if (matches) {
            // Javascript can get encoded URI
            str = decodeURIComponent(matches[1]);
        }
    }

    if (/youtube|youtu\.be|i.ytimg\./.test(str)) {
        metadata = {
            id: youtube(str),
            service: 'youtube'
        };
    } else if (/vimeo/.test(str)) {
        metadata = {
            id: vimeo(str),
            service: 'vimeo'
        };
    }
    return metadata;
};

function updateSelectedLangFooterText() {
    const selectedLanguage = getGobikCookie('gobik_selected_language');
    const selectedCountry = getGobikCookie('gobik_country_29-12');

    if (selectedLanguage && selectedCountry) {
        let selectedLanguageText = "";
        switch (selectedLanguage) {
            case "en":
                selectedLanguageText = "English";
                break;
            case "fr":
                selectedLanguageText = "French";
                break;
            case "es":
                selectedLanguageText = "Español";
                break;
            case "it":
                selectedLanguageText = "Italian";
                break;
        }


        $('.js-lang-current').text(selectedCountry + ' / ' + selectedLanguageText);
    }
}

function updateStoreLanguage(language) {
    if($('html').attr('lang') !== language) {
        Weglot.switchTo(language);
    }

    setTimeout(function() {
        $('.location-switcher .lang--selected').removeClass('lang--selected');
        $('.location-switcher [data-lang=' + language + ']').addClass('lang--selected');
        modalLocation(true);
    });
}

function handleCVOptions () {
	var $select = $('.js-handle-option-group');
	var $options = $('option', $select);
	var groups = [];

	for (var i = 0; i < $options.length; i++) {
		var $option = $($options[i]);
		var group = $option.attr('data-group');

		if (group) {
			if (!groups.includes(group)) {
				groups.push(group)

				var optgroup = document.createElement('optgroup');
				optgroup.setAttribute('label', group);

				$select.append(optgroup);
				$(optgroup).append($option);
			} else {
				$('optgroup[label="'+ group +'"]', $select).append($option)
			}
		}
	}
}

function handleCVSelect () {
	var $select = $('.js-handle-option-group');

	$select.on('change', function() {
		var value = $(this).val();

		if (value) {
			$('.block-' + value).toggleClass('active').siblings().removeClass('active');
		} else {
			$('#form-cv-sections .FeatureText').removeClass('active');
		}
	});
}

$(document).ready(function () {
    updateSelectedLangFooterText();
    $('.language-selector--wrapper').on('click', function () {
        if($($(this).parent()).hasClass('disabled')) {
            return;
        }
        $(this).toggleClass('active');
    });

    $(document).on('click', '.lang--option', function () {
        $($(this).parent().find('.lang--selected')).removeClass('lang--selected');
        $(this).addClass('lang--selected');

        if($(this).parent().hasClass('location-switcher')) {
            updateStoreLanguage($(this).attr('data-lang'));
        }
    });


    $('.modal-location-switcher__close').on('click', function () {
        $(`.modal-location-switcher__switcher .go-to-store-button[data-region-id=${$('#modalLocationSwitcher').attr('data-selected-region')}]`).click();
    });

    $('.modal-location-warning__close').on('click', function () {
        const date = new Date(
            new Date().getTime() + 1000 * 60 * 60 * 24
        );
        setGobikCookie('gobik_warning_modal_footer_mode', "true", {expires: date});

        $('.modal-location-warning--container.active').addClass('footer-mode');
        $('#shopify-section-location-warning').addClass('footer-mode');
    });

    $('.store-actions--wrapper.disabled').on('click', function () {
        const date = new Date(
            new Date().getTime() + 1000 * 60 * 60 * 24
        );
        setGobikCookie('gobik_warning_modal_footer_mode', "true", {expires: date});

        $('.modal-location-warning--container.active').addClass('footer-mode');
        $('#shopify-section-location-warning').addClass('footer-mode');
    });

    $('.js-lang-current').on('click', function() {
        document.getElementById('modalLocationSwitcher').classList.add("active");
        $('body').css({
            overflow: 'hidden'
        });
    });

    handleCVOptions();
    handleCVSelect();
});
